// This should be included in any page that has a shopping cart.
// If using the AJAX cart, this means it should be included in your main theme.
// If just using the cart page, you only need to embed it there.
var UpsellLive = (function() {

  return {
    processUpsellItem: function(evt, variantId, callback) {
      evt.preventDefault();
      if(this.customResolver) {
        var productHandle = $(evt.target).parents().filter('[data-product-handle]').data('product-handle');
        if(productHandle != null) {
          var self = this;
          Shopify.getProduct(productHandle, function(product) {
            self.customResolver(evt, product, variantId, function(properties) {
              self.addUpsellItem(variantId, callback, properties);
            });
          });
          return;
        }
      }

      // Otherwise, just go straight to adding the upsell item.
      this.addUpsellItem(variantId, callback, {});
    },

    addUpsellItem: function(variantId, callback, additionalProperties) {
      if(additionalProperties === undefined) {
        additionalProperties = {};
      }
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          'id': variantId,
          'properties': $.extend({'_origin': 'upsell'}, additionalProperties)
        },
        dataType: 'json',
        success: function(line_item) {
          if ((typeof callback) === 'function') {
            callback();
          } else {
            location.reload(true);
          }
        },
        error: function(XMLHttpRequest, textStatus) {
          var response = $.parseJSON(XMLHttpRequest.responseText);
          humanMsg.displayMsg('<div class="humanTitle">'+response.message+'</div><p>'+response.description+'</p>');
        }
      });
    },

    showUpsellVariants: function(evt, callback) {
      evt.preventDefault();
      var target = $(evt.target);

      // See how many variants are available.
      // If only one, go ahead and submit that one.
      var variantButtons = target.siblings('.upsell-variants').find('.upsell-button');
      if (variantButtons.length > 1) {
        target.hide();
        target.siblings('.upsell-variants').fadeIn(200);
      } else {
        this.processUpsellItem(evt, variantButtons.data('variant-id'), callback);
      }
    }
  };
})();

var loadScript = function(url, callback) {
  var script = document.createElement("script")
  script.type = "text/javascript";

  if (script.readyState){  //IE
    script.onreadystatechange = function() {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {  //Others
    script.onload = function() {
      callback();
    };
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
};

// if ((typeof jQuery === 'undefined') || (parseInt(jQuery.fn.jquery) === 1 && parseFloat(jQuery.fn.jquery.replace(/^1\./,'')) < 11)) {
//   loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.11.3/jquery.min.js');
// }
if ((typeof Shopify === 'undefined')) {
  loadScript('//cdn.shopify.com/s/assets/themes_support/api.jquery-e94e010e92e659b566dbc436fdfe5242764380e00398907a14955ba301a4749f.js');
}

// Minified version of Humanized Messages notification library (https://code.google.com/archive/p/humanmsg/)
var humanMsg={setup:function(s,n,u){humanMsg.msgID="humanMsg",humanMsg.logID="humanMsgLog",null==s&&(s="body"),null==n&&(n="Message Log"),humanMsg.msgOpacity=.8,null!=u&&(humanMsg.msgOpacity=parseFloat(u)),jQuery(s).append('<div id="'+humanMsg.msgID+'" class="humanMsg"><div class="round"></div><p></p><div class="round"></div></div> <div id="'+humanMsg.logID+'"><p>'+n+"</p><ul></ul></div>"),jQuery("#"+humanMsg.logID+" p").click(function(){jQuery(this).siblings("ul").slideToggle("50")})},displayMsg:function(s){""!=s&&(clearTimeout(humanMsg.t2),jQuery("#"+humanMsg.msgID+" p").html(s),jQuery("#"+humanMsg.msgID).show().animate({opacity:humanMsg.msgOpacity},200,function(){jQuery("#"+humanMsg.logID).show().children("ul").prepend("<li>"+s+"</li>").children("li:first").slideDown(200),"none"==jQuery("#"+humanMsg.logID+" ul").css("display")&&jQuery("#"+humanMsg.logID+" p").animate({bottom:40},200,"linear",function(){jQuery(this).animate({bottom:0},300,"easeOutBounce",function(){jQuery(this).css({bottom:0})})})}),humanMsg.t1=setTimeout("humanMsg.bindEvents()",700),humanMsg.t2=setTimeout("humanMsg.removeMsg()",6000))},bindEvents:function(){jQuery(window).mousemove(humanMsg.removeMsg).click(humanMsg.removeMsg).keypress(humanMsg.removeMsg)},removeMsg:function(){jQuery(window).unbind("mousemove",humanMsg.removeMsg).unbind("click",humanMsg.removeMsg).unbind("keypress",humanMsg.removeMsg),jQuery("#"+humanMsg.msgID).css("opacity")==humanMsg.msgOpacity&&jQuery("#"+humanMsg.msgID).animate({opacity:0},500,function(){jQuery(this).hide()})}};jQuery(document).ready(function(){humanMsg.setup()});
